import { Component } from 'react';

/** Components */
import BaseLayout from './BaseLayout';
import ChemistryKeypad from '../keypads/Chemistry';

class ChemistryLayout extends Component {
  render() {
    return (
      <div className="keypad-layout chemistry clearfix">
        <BaseLayout {...this.props} />
        <ChemistryKeypad {...this.props} />
      </div>
    );
  }
}

export default ChemistryLayout;
